var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[_c('router-link',_vm._b({style:(_vm.styles)},'router-link',_vm.$props,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }